// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Connection Item component
 */
!(function() {
  var React = require('react');
  var action = require('mobx').action;

  var classnames = require('classnames');
  var constants = require('logic/data/Izenda.ConnectionConstants');

  var uiState = require('logic/Izenda.UiState');

  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var connect = require('share/enhancers/Izenda.Connect');

  var ConnectionItem = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      dataSource: React.PropTypes.object.isRequired,
      isMiddlePanelMinimum: React.PropTypes.bool.isRequired
    },

    onToggleVisibility: function(e) {
      e.stopPropagation();
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var dataSource = this.props.dataSource;

      var message = this.props.dataSource.visible ? constants.VISIBLE_MESSAGE : constants.INVISIBLE_MESSAGE;

      props
        .confirmFn('Confirmation', {
          description: message
        })
        .then(loader.startLoading.bind(loader))
        .then(function() {
          return store.updateToggleVisibility(dataSource);
        })
        .finally(loader.endLoading.bind(loader));
      return false;
    },

    onDelete: function(e) {
      var props = this.props;
      var loader = props.loader;

      e.stopPropagation();
      props
        .confirmFn('Confirmation', {
          description: constants.DELETE_MESSAGE
        })
        .then(loader.startLoading.bind(loader))
        .then(function() {
          return props.store.deleteConnection(props.dataSource);
        })
        .finally(loader.endLoading.bind(loader));
    },

    onSelect: function(e) {
      e.stopPropagation();
      var store = this.props.store;
      var dataSource = this.props.dataSource;
      var loader = this.props.loader;
      var setConnection = action('setConnection', function() {
        store.item = dataSource;
      });

      // Only re-select a current item when it's actually differrent regarding to
      // its id value.
      if (store.item.id != dataSource.id) {
        this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(setConnection);
      }
    },

    render: function() {
      var dataSource = this.props.dataSource;
      var selectedId = this.props.store.item.id;
      var filter = this.props.store.filter;
      var localization = this.props.localization;

      var selectedClass = classnames('truncate', 'overflow-text', {
        selected: dataSource.id === selectedId
      });

      var serverTypeNameClasses = classnames('pull-left', {
        hidden: this.props.isMiddlePanelMinimum
      });

      var iconClasses = classnames(
        'white-space-normal',
        {
          'icon-eye': dataSource.visible,
          'icon-eye-off': !dataSource.visible
        },
        'pull-right'
      );

      var detectChangesIcon =
        dataSource.change !== constants.DETECTED_CHANGE_LEVEL.NONE ? (
          <span
            className='icon-attention warning-color pull-left'
            title={localization.getText('CONNECTION_DETECT_CHANGE_ICON_TOOLTIP')}
          />
        ) : (
          ''
        );
      var tooltip = '';
      tooltip = tooltip.concat('[', dataSource.serverTypeName, '] ', dataSource.name);
      return (
        <div>
          {/* confirm popup container prevent onclick event in popup to invoke the onSelect*/}
          <div className={selectedClass} onClick={this.onSelect}>
            <strong className={serverTypeNameClasses}>[{dataSource.serverTypeName}]&nbsp;</strong>
            <TextHighLight
              className='pull-left connection-string-name'
              highlight={filter}
              text={dataSource.name}
              tooltip={tooltip}
            />
            {detectChangesIcon}
            <span className='icon-cancel pull-right white-space-normal' onClick={this.onDelete} />
            <span className={iconClasses} onClick={this.onToggleVisibility} />
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(ConnectionItem);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionList/Izenda.ConnectionItem.jsx